import * as Localization from "expo-localization";

const languageDetector = {
	type: "languageDetector",
	async: true,
	detect: callback => {
		try {
			// getLocales() is synchronous and returns an array of locale objects
			// We take the first locale which is the user's preferred language
			const locales = Localization.getLocales();
			const firstLocale = locales?.[0];

			// Extract language code from languageTag (e.g., "fr-FR" -> "fr")
			// or use languageCode directly if available
			const lang =
				firstLocale?.languageCode ||
				firstLocale?.languageTag?.split("-")[0] ||
				"en";

			// Call callback synchronously but return a resolved promise for async compatibility
			callback(lang);
			return Promise.resolve();
		} catch (error) {
			// Fallback to "en" if there's any error
			callback("en");
			return Promise.resolve();
		}
	},
	init: () => {},
	cacheUserLanguage: () => {}
};

export default languageDetector;
